import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink, useParams } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import axiosInstance from '../../../lib/axiosIntercepter';
import { useContext, useEffect, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';


import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import SearchIcon from '@mui/icons-material/Search';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import TablePagination from '@mui/material/TablePagination';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { pink } from '@mui/material/colors';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];
export default function CreateAutomation() {
  const { productType } = useParams();

   const [pages, setPages] = React.useState(2);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [customerList, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  // Add ref to prevent double submission in StrictMode
  const isSubmittingRef = useRef(false);

  // Form states
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    triggerType: '',
    triggerExceptions: [],
    effectType: '',
    effectEmailTemplate: '',
    effectAdHocEmail: '',
    effectStatus: '',
    effectSubStatus: '',
    runType: 'Immediately',
    scheduleTime: '',
    scheduleNumber: '',
    scheduleUnit: 'Hours',
    deleteOnStatusChange: false,
    onSuccessAction: '',
    onSuccessStatus: '',
    isActive: true
  });

  // Email templates state
  const [emailTemplates, setEmailTemplates] = useState([]);

  // Status and Sub-Status state
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [leadSubStatuses, setLeadSubStatuses] = useState([]);

  // Search states
  const [searchFields, setSearchFields] = useState({
    id: '',
    name: '',
    email: '',
    phone: '',
  });

  const authCtx = useContext(AuthContext);
  const debounceRef = useRef();

  // Function to format product type for display
  const getProductTypeDisplay = () => {
    if (!productType) return 'All Products';
    
    switch (productType.toLowerCase()) {
      case 'will':
        return 'Will';
      case 'conveyancing':
        return 'Conveyancing';
      case 'allproducts':
      case 'all-products':
        return 'All Products';
      case 'lsswill':
        return 'LSS Will';
      case 'lsslastingpowers':
        return 'LSS Lasting Powers of Attorney';
      case 'lssestate':
        return 'LSS Estate Administration';
      case 'lssgrant':
        return 'LSS Grant Application';
      case 'lastingpowers':
        return 'Lasting Powers of Attorney';
      default:
        // Capitalize first letter for any other cases
        return productType.charAt(0).toUpperCase() + productType.slice(1);
    }
  };

  // Fetch email templates
  const fetchEmailTemplates = async () => {
    try {
      const response = await axiosInstance.post('private/email-templates', {
        page: 1,
        limit: 100,
        isActive: 'true'
      });
      const data = response.data;

      if (data.status === 200) {
        setEmailTemplates(data.data.templates || []);
      }
    } catch (error) {
      console.error('Error fetching email templates:', error);
      setEmailTemplates([]);
    }
  };

  // Fetch lead statuses - DISABLED
  // const fetchLeadStatuses = async () => {
  //   try {
  //     const response = await postRequest('private/getLeadStatuses', {}, authCtx.token);
  //     if (response?.data) {
  //       setLeadStatuses(response.data);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching lead statuses:', error);
  //     setLeadStatuses([]);
  //   }
  // };

  // Fetch lead sub-statuses
  const fetchLeadSubStatuses = async () => {
    try {
      const response = await postRequest('private/statusAndSubStatusList', {
        page: 1,
        limit: 100,
        isDeleted: 0
      }, authCtx.token);
      if (response?.data && response.data.docs) {
        setLeadSubStatuses(response.data.docs || []);
      }
    } catch (error) {
      console.error('Error fetching lead sub-statuses:', error);
      setLeadSubStatuses([]);
    }
  };

  // Fetch customers
  const fetchCustomers = async (payloadFields = searchFields, pageVal = page) => {
    const payload = {
      ...payloadFields,
      page: pageVal,
      limit: 5,
    };

    setLoading(true);
    try {
      const response = await postRequest('private/customerList', payload, authCtx.token);
      if (response?.data) {
        setCustomerList(response.data.docs || []);
        setTotalPages(response.data.totalPages || 1);
      } else {
        setCustomerList([]);
        setTotalPages(1);
      }
    } catch (err) {
      setCustomerList([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  // On initial load and page change
  useEffect(() => {
    fetchCustomers(searchFields, page);
    // eslint-disable-next-line
  }, [page]);

  // Fetch email templates, statuses, and sub-statuses on component mount
  useEffect(() => {
    if (authCtx.token) {
      fetchEmailTemplates();
      // fetchLeadStatuses(); // DISABLED - API call removed
      fetchLeadSubStatuses();
    }
  }, [authCtx.token]);

  // Debounced search on fields change
  useEffect(() => {
    setPage(1);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchCustomers(searchFields, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchFields]);

  // Handle individual search input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchFields((prev) => ({ ...prev, [name]: value }));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleDelete = async (userId) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this customer ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      try {
        const response = await postRequest(`private/deleteCustomer/${userId}`,{}, authCtx.token);
        if (response?.status === 200 || response?.success) {
          Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
          fetchCustomers(searchFields, page);
        } else {
          Swal.fire('Error', response?.message || 'Failed to delete customer', 'error');
        }
      } catch (err) {
        Swal.fire('Error', err?.message || 'Failed to delete customer', 'error');
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent double submission using ref
    if (isSubmittingRef.current) {
      console.log('⚠️ Form is already being submitted, ignoring duplicate submission');
      return;
    }
    
    if (!formData.triggerType) {
      Swal.fire('Error', 'Please select a trigger type', 'error');
      return;
    }
    
    if (!formData.effectType) {
      Swal.fire('Error', 'Please select an effect type', 'error');
      return;
    }
    
    // Auto-generate name based on trigger and effect
    const autoName = `${formData.triggerType} → ${formData.effectType}`;

    // Map frontend field names to backend field names
    const submitData = {
      ...formData,
      name: autoName,
      productType: productType, // Include productType from URL parameter
      created_id: localStorage.getItem('id') || authCtx.user?.id || '',
    };

    // Only include effectEmailTemplateId if it has a value
    if (formData.effectEmailTemplate) {
      submitData.effectEmailTemplateId = formData.effectEmailTemplate;
    }

    // Only include ad hoc email if it has a value
    if (formData.effectAdHocEmail) {
      submitData.effectAdHocEmail = formData.effectAdHocEmail;
    }

    // Remove the old field name to avoid confusion
    delete submitData.effectEmailTemplate;
    
    // Set submitting flag
    isSubmittingRef.current = true;
    setLoading(true);
    console.log('🚀 Submitting automation data:', submitData);
    try {
      console.log('📡 Making API call to:', 'createAutomation');
      console.log('🔑 Auth token:', authCtx.token ? 'Present' : 'Missing');
      const response = await postRequest('createAutomation', submitData, authCtx.token);
      console.log('📡 API Response:', response);
      console.log('📡 Response status:', response?.status);
      console.log('📡 Response data:', response?.data);
      
      if (response?.status === 'success') {
        Swal.fire('Success', 'Automation created successfully!', 'success');
        // Reset form
        setFormData({
          name: '',
          description: '',
          triggerType: '',
          triggerExceptions: [],
          effectType: '',
          effectEmailTemplate: '',
          effectAdHocEmail: '',
          effectStatus: '',
          effectSubStatus: '',
          runType: 'Immediately',
          scheduleTime: '',
          scheduleNumber: '',
          scheduleUnit: 'Hours',
          deleteOnStatusChange: false,
          onSuccessAction: '',
          onSuccessStatus: '',
          isActive: true
        });
      } else {
        console.error('❌ Response not successful:', response);
        const errorMessage = response?.message || response?.data?.message || 'Failed to create automation';
        Swal.fire('Error', errorMessage, 'error');
      }
    } catch (err) {
      console.error('❌ Automation creation error:', err);
      console.error('❌ Error type:', typeof err);
      
      // Try to safely stringify the error
      try {
        console.error('❌ Error details:', JSON.stringify(err, null, 2));
      } catch (stringifyError) {
        console.error('❌ Error stringification failed, raw error:', err);
      }
      
      let errorMessage = 'Failed to create automation';
      
      // Safe error message extraction
      try {
        if (err && typeof err === 'object') {
          if (err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          } else if (err.message && typeof err.message === 'string') {
            errorMessage = err.message;
          } else if (err.data && err.data.message) {
            errorMessage = err.data.message;
          } else if (typeof err === 'string') {
            errorMessage = err;
          }
        }
      } catch (extractError) {
        console.error('❌ Error message extraction failed:', extractError);
        errorMessage = 'An unexpected error occurred';
      }
      
      Swal.fire('Error', errorMessage, 'error');
    } finally {
      setLoading(false);
      // Reset submitting flag
      isSubmittingRef.current = false;
    }
  };

  // Handle form field changes
  const handleFieldChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };
  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Automation', path: '/automation' },
          { label: 'Create Automation', path: '' },
        ]}
      />
      <br />
      
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Create Automation ({getProductTypeDisplay()})</h1>
       
      </div>

      {/* Search Form */}
      <div className='page-top-formview mb-3'>
       
         <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
             <h5>Trigger</h5>
            <Form.Group as={Col} controlId="triggerType">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <InputLabel id="trigger-type-label">Type</InputLabel>
        <Select
          labelId="trigger-type-label"
          id="trigger-type"
          value={formData.triggerType}
          label="Type"
          onChange={(e) => handleFieldChange('triggerType', e.target.value)}
        >
          <MenuItem value='Quotes/Generate New Quote'>Quotes/Generate New Quote</MenuItem>
          <MenuItem value='Quotes/Revise Quote'>Quotes/Revise Quote</MenuItem>
          <MenuItem value='Lead Created'>Lead Created</MenuItem>
          <MenuItem value='Status Change'>Status Change</MenuItem>
          <MenuItem value='Task Created'>Task Created</MenuItem>
        </Select>
        <FormHelperText className='custom-helper-css red-link-text'>Add Trigger Exception</FormHelperText>
                                </FormControl>
            </Form.Group>
            </Row>
          <Row className="mb-3">
             <h5>Effect</h5>
            <Form.Group as={Col} controlId="effectType">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <InputLabel id="effect-type-label">Type</InputLabel>
        <Select
          labelId="effect-type-label"
          id="effect-type"
          value={formData.effectType}
          label="Type"
          onChange={(e) => handleFieldChange('effectType', e.target.value)}
        >
          <MenuItem value='Send Email to customer'>Send Email to customer</MenuItem>
          <MenuItem value='Send SMS to customer'>Send SMS to customer</MenuItem>
          <MenuItem value='Change Lead Status'>Change Lead Status</MenuItem>
            <MenuItem value='Create task'>Create task</MenuItem>
              <MenuItem value='Send email (Ad Hoc)'>Send email (Ad Hoc)</MenuItem>
        </Select>
                                </FormControl>
            </Form.Group>

            {/* Email Template field - show only when Send Email to customer is selected */}
            {formData.effectType === 'Send Email to customer' && (
              <Form.Group as={Col} controlId="effectEmailTemplate">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                  <InputLabel id="email-template-label">Email Template</InputLabel>
                  <Select
                    labelId="email-template-label"
                    id="email-template"
                    value={formData.effectEmailTemplate}
                    label="Email Template"
                    onChange={(e) => handleFieldChange('effectEmailTemplate', e.target.value)}
                  >
                    <MenuItem value="">Select Email Template</MenuItem>
                    {emailTemplates
                      .filter((template) => {
                        // If productType is 'allproducts', show all templates
                        if (productType === 'allproducts') {
                          return true;
                        }
                        // Otherwise, filter by product type
                        const templateProductTitle = template.productId?.title?.toLowerCase() || '';
                        const currentProductType = productType?.toLowerCase() || '';

                        // Map product types to match template product titles
                        if (currentProductType === 'will') {
                          return templateProductTitle.includes('will') && !templateProductTitle.includes('lss');
                        } else if (currentProductType === 'conveyancing') {
                          return templateProductTitle.includes('conveyancing');
                        } else if (currentProductType === 'lsswill') {
                          return templateProductTitle.includes('lss') && templateProductTitle.includes('will');
                        } else if (currentProductType === 'lsslastingpowers') {
                          return templateProductTitle.includes('lss') && templateProductTitle.includes('lasting powers');
                        } else if (currentProductType === 'lssestate') {
                          return templateProductTitle.includes('lss') && templateProductTitle.includes('estate');
                        } else if (currentProductType === 'lssgrant') {
                          return templateProductTitle.includes('lss') && templateProductTitle.includes('grant');
                        } else if (currentProductType === 'lastingpowers') {
                          return templateProductTitle.includes('lasting powers') && !templateProductTitle.includes('lss');
                        }
                        return false;
                      })
                      .map((template) => (
                        <MenuItem key={template._id} value={template._id}>
                          {template.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Form.Group>
            )}

            {/* Ad Hoc Email field - show only when Send email (Ad Hoc) is selected */}
            {formData.effectType === 'Send email (Ad Hoc)' && (
              <Form.Group as={Col} controlId="effectAdHocEmail">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                  <TextField
                    id="ad-hoc-email"
                    label="Email Address"
                    type="email"
                    value={formData.effectAdHocEmail}
                    onChange={(e) => handleFieldChange('effectAdHocEmail', e.target.value)}
                    variant="outlined"
                    fullWidth
                    placeholder="Enter email address"
                  />
                </FormControl>
              </Form.Group>
            )}

            {/* Status and Sub-Status fields - show only when Change Lead Status is selected */}
            {formData.effectType === 'Change Lead Status' && (
              <>
                <Form.Group as={Col} controlId="effectStatus">
                  <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                    <InputLabel id="effect-status-label">Status</InputLabel>
                    <Select
                      labelId="effect-status-label"
                      id="effect-status"
                      value={formData.effectStatus}
                      label="Status"
                      onChange={(e) => handleFieldChange('effectStatus', e.target.value)}
                    >
                      <MenuItem value="">Select Status</MenuItem>
                      <MenuItem value="Pending">Pending</MenuItem>
                      <MenuItem value="New">New</MenuItem>
                      <MenuItem value="Quote sent">Quote sent</MenuItem>
                      <MenuItem value="Instructed">Instructed</MenuItem>
                      <MenuItem value="Exported">Exported</MenuItem>
                      <MenuItem value="Not Interested">Not Interested</MenuItem>
                    </Select>
                  </FormControl>
                </Form.Group>

                <Form.Group as={Col} controlId="effectSubStatus">
                  <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                    <InputLabel id="effect-substatus-label">Sub-Status</InputLabel>
                    <Select
                      labelId="effect-substatus-label"
                      id="effect-substatus"
                      value={formData.effectSubStatus}
                      label="Sub-Status"
                      onChange={(e) => handleFieldChange('effectSubStatus', e.target.value)}
                    >
                      <MenuItem value="">Select Sub-Status</MenuItem>
                      {leadSubStatuses.map((subStatus) => (
                        <MenuItem key={subStatus._id || subStatus} value={subStatus.status || subStatus}>
                          {subStatus.status || subStatus}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Form.Group>
              </>
            )}

            <Form.Group className='mt-3'>
                    <FormControl>
      <h5>Run</h5>
      <RadioGroup
        row
        aria-labelledby="run-type-radio-group"
        name="runType"
        value={formData.runType}
        onChange={(e) => handleFieldChange('runType', e.target.value)}
      >
        <FormControlLabel value="Immediately" control={<Radio />} label="Immediately" />
        <FormControlLabel value="Schedule" control={<Radio />} label="Schedule For Future" />
       
      </RadioGroup>
    </FormControl>
    
    {/* Schedule fields - show only when Schedule For Future is selected */}
    {formData.runType === 'Schedule' && (
      <Row className="mt-3">
        <Col md={6}>
          <TextField
            label="Num"
            variant="outlined"
            fullWidth
            value={formData.scheduleNumber || ''}
            onChange={(e) => handleFieldChange('scheduleNumber', e.target.value)}
            type="number"
            size="small"
          />
        </Col>
        <Col md={6}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Hours</InputLabel>
            <Select
              value={formData.scheduleUnit || 'Hours'}
              label="Hours"
              onChange={(e) => handleFieldChange('scheduleUnit', e.target.value)}
            >
              <MenuItem value="Hours">Hours</MenuItem>
              <MenuItem value="Working days">Working days</MenuItem>
              <MenuItem value="Calender days">Calender days</MenuItem>
              <MenuItem value="Weeks">Weeks</MenuItem>
               <MenuItem value="Months">Months</MenuItem>
            </Select>
          </FormControl>
        </Col>
      </Row>
    )}
            </Form.Group>
            <Form.Group className='mt-3'>
          
  <FormControlLabel 
    control={<Checkbox  
      checked={formData.deleteOnStatusChange}
      onChange={(e) => handleFieldChange('deleteOnStatusChange', e.target.checked)}
      sx={{
        color: '#0009',
        '&.Mui-checked': {
          color: '#bb0000',
        },
      }}
    />} 
    label="Delete on Status Change" 
  />
            </Form.Group>
            
            </Row>
            <Row className="mb-3">
             <h5>On Success</h5>
            <Form.Group as={Col} controlId="onSuccessAction">

               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <InputLabel id="on-success-label">Action</InputLabel>
        <Select
          labelId="on-success-label"
          id="on-success"
          value={formData.onSuccessAction}
          label="Action"
          onChange={(e) => handleFieldChange('onSuccessAction', e.target.value)}
        >
          <MenuItem value=''>None</MenuItem>
          <MenuItem value='Send Email to customer'>Send Email to customer</MenuItem>
          <MenuItem value='Send SMS to customer'>Send SMS to customer</MenuItem>
          <MenuItem value='Change Lead Status'>Change Lead Status</MenuItem>
            <MenuItem value='Create task'>Create task</MenuItem>
              <MenuItem value='Send email (Ad Hoc)'>Send email (Ad Hoc)</MenuItem>
        </Select>
                                </FormControl>
            </Form.Group>

            {/* Status field for On Success - show only when Change Lead Status is selected */}
            {formData.onSuccessAction === 'Change Lead Status' && (
              <Form.Group as={Col} controlId="onSuccessStatus">
                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                  <InputLabel id="on-success-status-label">Status</InputLabel>
                  <Select
                    labelId="on-success-status-label"
                    id="on-success-status"
                    value={formData.onSuccessStatus || ''}
                    label="Status"
                    onChange={(e) => handleFieldChange('onSuccessStatus', e.target.value)}
                  >
                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="New">New</MenuItem>
                    <MenuItem value="Quote sent">Quote sent</MenuItem>
                    <MenuItem value="Instructed">Instructed</MenuItem>
                    <MenuItem value="Exported">Exported</MenuItem>
                    <MenuItem value="Not Interested">Not Interested</MenuItem>
                  </Select>
                </FormControl>
              </Form.Group>
            )}
            </Row>
            <Row>
           
            <Form.Group as={Col} controlId="buttons">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <Stack spacing={2} direction="row">
                                    <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/automation" className="red-link-text">
                Cancel
              </NavLink>
            </Button>
                                <Button 
                                  variant="contained" 
                                  type="submit" 
                                  className='red-bg red-button text-capitalize h-56'
                                  disabled={loading}
                                >
                                  {loading ? <CircularProgress size={20} color="inherit" /> : 'Save'}
                                </Button>

                            </Stack>
                                </FormControl>
            </Form.Group>


          </Row>
        </Form> 
         


      </div>

      {/* Table View */}
      <div>
        

        {/* Pagination */}
        {customerList.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              size="medium"
              sx={{
                '& .Mui-selected': {
                  backgroundColor: '#bb0000 !important',
                  color: '#fff !important',
                },
                '& .MuiPaginationItem-root': {
                  color: '#bb0000',
                  borderColor: '#bb0000',
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}
